module.exports = __webpack_public_path__ + "media/images/emoticons/wave-63ad6ae72a37d283c5dee05c49e94fd9.gif";